import { render, staticRenderFns } from "./Inventory_component.vue?vue&type=template&id=2621565e&scoped=true&"
import script from "./Inventory_component.vue?vue&type=script&lang=js&"
export * from "./Inventory_component.vue?vue&type=script&lang=js&"
import style0 from "./Inventory_component.vue?vue&type=style&index=0&id=2621565e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2621565e",
  null
  
)

export default component.exports